import React from 'react';
import './AdvisorModal.scss';
import { useSelector } from 'react-redux';
import { getAdvisoryDetails } from '../../redux/modules/advisoryDetails/advisoryDetails.selectors';
import EmailIcon from '../../assets/images/email-icon.svg';
import PhoneIcon from '../../assets/images/phone-icon.svg';
import Button from '../Shared/Button/Button';
import {
  RAS_GENERAL_TIMETRADE_SCHEDULING_URL,
  RAS_SUPPORT_PHONE_NUMBER,
} from '../../settings/settings';
import {
  findFinancialAdvisor,
  getSelectedHousehold,
} from '../../utils/advice/advice-utility';
import { getAdvisors } from '../../redux/modules/advisors/advisors.selectors';

const AdvisorModal = ({ isMobile, title, description, fund }) => {
  const allHouseholds = useSelector(getAdvisoryDetails);
  const household = getSelectedHousehold(
    allHouseholds,
    fund?.financialPlanningGroupID
  );
  const financialAdvisors = useSelector(getAdvisors);
  const financialAdvisor = findFinancialAdvisor(
    allHouseholds,
    financialAdvisors,
    household?.externalHouseholdId
  );

  const financialAdvisorName = financialAdvisor?.advisorName;
  const financialAdvisorTitle = financialAdvisor?.advisorTitle;
  const financialAdvisorEmail = financialAdvisor?.advisorEmail;
  const financialAdvisorPhone = financialAdvisor?.advisorPhone;
  const hasFinancialAdvisorInfo =
    financialAdvisorName && financialAdvisorEmail && financialAdvisorPhone;
  // formats phone number to ###-###-####
  const formattedFinancialAdvisorPhone = hasFinancialAdvisorInfo
    ? financialAdvisorPhone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    : RAS_SUPPORT_PHONE_NUMBER;
  const clickablePhoneNumberLink = 'tel:' + financialAdvisorPhone;
  const clickableEmailLink = 'mailto:' + financialAdvisorEmail;
  const financialAdvisorLink =
    financialAdvisor?.pointOfContactLink ||
    RAS_GENERAL_TIMETRADE_SCHEDULING_URL;

  return (
    <div className="financial-advisor-modal">
      {title}
      <div className="financial-advisor-modal-description">{description}</div>
      {hasFinancialAdvisorInfo && (
        <div>
          <div className="financial-advisor-name">{financialAdvisorName}</div>
          <div className="financial-advisor-title">{financialAdvisorTitle}</div>
          <hr />
          <img alt="email-icon" className="email-icon" src={EmailIcon} />
          <div className="financial-advisor-email">
            {isMobile ? (
              <a href={clickableEmailLink}>{financialAdvisorEmail}</a>
            ) : (
              financialAdvisorEmail
            )}
          </div>
        </div>
      )}
      <hr />
      <img alt="phone-icon" className="phone-icon" src={PhoneIcon} />
      <div className="financial-advisor-phone">
        {isMobile ? (
          <a href={clickablePhoneNumberLink}>
            {' '}
            {formattedFinancialAdvisorPhone}{' '}
          </a>
        ) : (
          formattedFinancialAdvisorPhone
        )}
      </div>
      <div className="schedule-appointment-banner">
        <a href={financialAdvisorLink}>
          <Button className="btn btn-trp-primary">
            {' '}
            Schedule Appointment{' '}
          </Button>
        </a>
      </div>
    </div>
  );
};

export default AdvisorModal;
